import { SxProps, Theme } from "@mui/material";

// Common style objects for ChartsReport
export const chartsReportStyles = {
  // Container styles
  container: {
    width: "100%",
    mt: 2,
    mb: 2,
    backgroundColor: "white",
    borderRadius: 2,
    border: "1px solid #E0E0E0",
    padding: 2,
  } as SxProps<Theme>,

  // Title container styles
  titleContainer: {
    display: "flex",
    alignItems: "center",
    mb: 0.5,
  } as SxProps<Theme>,

  // Accent rectangle styles
  accentRectangle: {
    width: "4px",
    height: "20px",
    backgroundColor: "#003057",
    marginRight: 1.5,
    borderRadius: "2px",
  } as SxProps<Theme>,

  // Title text styles
  title: {
    color: "#003057",
    fontWeight: "bold",
    fontSize: "1.25rem",
    fontFamily: '"Poppins", sans-serif',
  } as SxProps<Theme>,

  // Subtitle styles
  subtitle: {
    color: "#666",
    fontSize: "0.8rem",
    mb: 2,
    ml: 6, // Align with title text (accent + margin)
    fontFamily: '"Poppins", sans-serif',
  } as SxProps<Theme>,

  // Chart container styles
  chartContainer: {
    width: "100%",
    height: 300,
  } as SxProps<Theme>,
};

// Chart configuration constants for @mui/x-charts
export const chartConfig = {
  height: 300,
  margin: { top: 10, bottom: 55, left: 100, right: 20 }, // Base left margin for large values
  lineColor: "#2C8BB0",
  curve: "monotoneX" as const,
};

// X-axis configuration
export const xAxisConfig = {
  valueFormatter: (date: Date) => date.toLocaleDateString(),
  scaleType: "time" as const,
};

// Y-axis configuration
export const yAxisConfig = {
  valueFormatter: (value: number) =>
    new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(value),
};

// Series configuration
export const seriesConfig = {
  showMark: false,
  curve: chartConfig.curve,
  color: chartConfig.lineColor,
};
